export enum DataHooks {
  ROOT = 'details-root',
}
